import { makeStyles } from "@material-ui/core"

const underlineColor = "#7c7c7c"

export default makeStyles(() => ({
    input: {
        fontSize: "1rem!important",
        textTransform: "uppercase"
    },
    textField: {
        // input label when focused
        "& label.Mui-focused": {
            color: underlineColor
        },
        // focused color for input with variant='standard'
        "& .MuiInput-underline:after": {
            borderBottomColor: underlineColor
        },
        // focused color for input with variant='filled'
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: underlineColor
        },
        // focused color for input with variant='outlined'
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: underlineColor
            }
        },
        "& .MuiInput-root": {
            paddingBottom: "0px!important"
        }
    }
}))
